import React from 'react';
import { Box } from '@mui/material';
import { Button, Typography } from '@sm-dashboard/ui-components';
import { CheckCircleOutline } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

interface SubmissionSuccessProps {
  title: string;
  message: string;
  showSubmitAnother?: boolean;
  submitAnotherLink?: string;
  submitAnotherText?: string;
  onSubmitAnother?: () => void;
}

const SubmissionSuccess: React.FC<SubmissionSuccessProps> = ({
  title,
  message,
  showSubmitAnother = true,
  submitAnotherLink = '/',
  submitAnotherText = 'חזור לדף הבית',
  onSubmitAnother
}) => {
  const button = onSubmitAnother ? (
    <Button variant="outlined" onClick={onSubmitAnother}>
      {submitAnotherText}
    </Button>
  ) : (
    <RouterLink to={submitAnotherLink} style={{ textDecoration: 'none' }}>
      <Button variant="outlined">{submitAnotherText}</Button>
    </RouterLink>
  );

  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 8,
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
      }}
    >
      <CheckCircleOutline sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
      <Box sx={{ mb: '0.35em' }}>
        <Typography variant="h1">{title}</Typography>
      </Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="body" color="text.secondary">
          {message}
        </Typography>
      </Box>
      {showSubmitAnother && button}
    </Box>
  );
};

export default SubmissionSuccess;
